import React, { useEffect, useState } from 'react';
import { copyText } from '../../../clipboard';

// Modèle de texte prêt à copier (faire-part, message, relance…)
export interface Template {
  title: string;
  text: string;
}

const TemplateCard: React.FC<{ template: Template }> = ({ template }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  const copy = async () => {
    try {
      await copyText(template.text);
      setCopied(true);
    } catch {
      /* copie impossible : le texte reste sélectionnable à la main */
    }
  };

  return (
    <div className="mg-template">
      <div className="mg-template-head">
        <b>{template.title}</b>
        <button type="button" onClick={copy} aria-live="polite">
          {copied ? 'Copié ✓' : 'Copier'}
        </button>
      </div>
      <p>{template.text}</p>
    </div>
  );
};

export default TemplateCard;
